import {
  ScreenTracking,
  WAITLIST_SCREEN_ASSET_ID
} from '../../domain/amplitude'

export const WaitlistScreenOpened: ScreenTracking = {
  asset_id: WAITLIST_SCREEN_ASSET_ID,
  screen: 'apply',
  heading: 'Coming Soon',
  from_screen: '..many..'
}

export type WaitlistFormProps = {
  onSubmit: (email: string) => void
  isLoading?: boolean
}

export const CARD_PROGRAM = "boost_amex"
